import React, { useEffect, useState, useRef } from 'react';
import Header from '../components/header';
import { API_KEY } from '../utils/constants';
import { userDataAPI, updateUserAvatarAPI, changeUserNameAPI } from '../api/api';
import Loader from '../components/loader';
import { toast } from "react-toastify";

function Profile() {
  const [user, setUser] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [selectedImage, setSelectedImage] = useState(null);
  const [showEditDialog, setShowEditDialog] = useState(false);
  const [newUsername, setNewUsername] = useState('');
  const fileInputRef = useRef(null);

  useEffect(() => {
  
    window.myFunction = function() {
      console.log("This is a test function.");
  };
  
    
    window.onImagePicked = async (base64String) => {
      console.log("Received base64 string:", base64String);
      const file = base64ToFile(base64String, "profile_image.png");
      setSelectedImage(URL.createObjectURL(file));
     await uploadImage(file);
    };
    
   
   
    /*
    window.onImagePicked = () => {
      console.log("Received base64 string:", "Hello");
    //  setSelectedImage(`data:image/png;base64,${base64String}`);
      //uploadImage(base64String);
    };
    */
  
    console.log("window.onImagePicked is set!");
  
    getUserData();
  }, []);

    // Function to Convert Base64 to File
    const base64ToFile = (base64String, fileName) => {
      const byteCharacters = atob(base64String);
      const byteArrays = [];
      
      for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512);
        const byteNumbers = new Array(slice.length).fill(0).map((_, i) => slice.charCodeAt(i));
        byteArrays.push(new Uint8Array(byteNumbers));
      }
      
      return new File(byteArrays, fileName, { type: "image/png" });
    };
    
  const getUserData = async () => {
    try {
      const userData = await localStorage.getItem('user');
      const user_uid = JSON.parse(userData)?.uid;

      const formData = new FormData();
      formData.append('__api_key__', API_KEY);
      formData.append('user_uid', user_uid);

      const res = await userDataAPI(formData);
      if (res.data.state === 'OK') {
        setUser(res.data.data.user_entity);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  
  /*
  const handleEditPhoto = () => {

    fileInputRef.current.click();

  };
  */


  const handleEditPhoto = () => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage("open_image_picker");
    } else {
      fileInputRef.current.click(); // Open file picker normally
    }
  };
  

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setSelectedImage(URL.createObjectURL(file));
    await uploadImage(file);
  };

  const uploadImage = async (file) => {
    setIsLoading(true);
    try {
      const userData = await localStorage.getItem('user');
      const user_uid = JSON.parse(userData)?.uid;

      const formData = new FormData();
      formData.append('__api_key__', API_KEY);
      formData.append('user_uid', user_uid);
      formData.append('avatar', file);

      const response = await updateUserAvatarAPI(formData);
      if (response.data.state === 'OK') {
        setUser((prevUser) => ({
          ...prevUser,
          avatar: response.data.data.avatar,
        }));
      }
    } catch (error) {
      console.error('Image upload failed:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleOpenEditDialog = () => {
    setNewUsername('');
    setShowEditDialog(true);
  };

  const handleCloseEditDialog = () => {
    setShowEditDialog(false);
  };

  const handleSubmitNewName = async () => {
    setIsLoading(true);
    try {
      const userData = await localStorage.getItem('user');
      const user_uid = JSON.parse(userData)?.uid;

      const formData = new FormData();
      formData.append('__api_key__', API_KEY);
      formData.append('user_uid', user_uid);
      formData.append('name', newUsername);

      const response = await changeUserNameAPI(formData);
      
      if (response.data.state === 'OK') {
        toast.success('Name change request submitted successfully. Awaiting admin approval.')
        setShowEditDialog(false);
        getUserData()
      } else {
        toast.error(response.data.message || 'Failed to submit request.'); 
      }
    } catch (error) {
      console.error('Error submitting name change request:', error);
      toast.error('Name change failed. Please try again.');

    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className='main-2 bg-3'>
      <Header title='Edit Profile' isMenu />
      <div className='container mx-auto'>
        <div className='text-center mt-4 position-relative' style={{ width: 150, margin: '0 auto' }}>
          <img
            src={selectedImage || user.avatar || './images/avatar.png'}
            style={{ width: 140, height: 140, borderRadius: '50%', backgroundColor: '#fff', padding: 5 }}
            alt='profile'
          />
          <i
            className='bi bi-pencil-fill position-absolute'
            style={{
              height: '45px',
              width: '45px',
              bottom: 10,
              right: 1,
              background: '#fff',
              borderRadius: '50%',
              padding: '10px',
              fontSize: '18px',
              cursor: 'pointer',
            }}

            onClick={() => {
              if (window.Android) {
                window.Android.openImagePicker();
              } else {
                handleEditPhoto();
              }
            }}
          ></i>

        </div>

        <div className='w-100 bg-white shadow-sm rounded-4 p-3 mt-4 text-start d-flex justify-content-between align-items-center'>
          <div>
            <h6>User Name</h6>
            <text>
              <i className='bi bi-person-fill me-2' />
              {user.username}
            </text>
          </div>

          <p 
            style={{ fontSize: '16px', color: '#191919', cursor: 'pointer', marginTop: '0px' }} 
            className="d-flex align-items-center"
            onClick={handleOpenEditDialog}
          >
            <i className="bi bi-pencil-fill" />
          </p>
        </div>

        <div className='w-100 bg-white shadow-sm rounded-4 p-3 mt-3 text-start'>
          <h6>Email Address</h6>
          <text>
            <i className='bi bi-envelope me-2' />
            {user.email || 'Username@gmail.com'}
          </text>
        </div>
        <div className='w-100 bg-white shadow-sm rounded-4 p-3 mt-3 text-start'>
          <h6>Phone Number</h6>
          <text>
            <i className='bi bi-phone me-2' />
            {user.phone}
          </text>
        </div>
        <div className='w-100 bg-white shadow-sm rounded-4 p-3 mt-3 text-start'>
          <h6>City</h6>
          <text>
            <i className='bi bi-geo-alt-fill me-2' />
            {user.city}
          </text>
        </div>
        <div className='w-100 bg-white shadow-sm rounded-4 p-3 mt-3 text-start' style={{ marginBottom: '40px' }}>
          <h6>State</h6>
          <text>
            <i className='bi bi-geo-fill me-2' />
            {user.state}
          </text>
        </div>
      </div>

      <input
        type='file'
        ref={fileInputRef}
        style={{ display: 'none' }}
        accept='image/*'
        onChange={handleFileChange}
      />

      {showEditDialog && (
        <div 
          className='position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center' 
          style={{ background: 'rgba(0, 0, 0, 0.5)' }}
        >
          <div className='bg-white p-4 rounded-3 shadow-lg' style={{ width: '90%', maxWidth: '400px' }}>
            <h5>Change User Name</h5>
            <p className='text-muted'>Enter a new username below.</p>
            <input 
              type="text" 
              className="form-control mb-3"
              value={newUsername}
              onChange={(e) => setNewUsername(e.target.value)}
            />
            <p className="text-danger small">*Applicable charges will be deducted for changing the name. The name will be updated upon admin approval of the request.</p>
            <div className='d-flex justify-content-between mt-3'>
              <button className='btn btn-secondary' onClick={handleCloseEditDialog}>Cancel</button>
              <button className='btn btn-primary' onClick={handleSubmitNewName}>Submit</button>
            </div>
          </div>
        </div>
      )}

      <Loader isLoading={isLoading} />
    </div>
  );
}

export default Profile;
